import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'pt-two-factor-authentication-reset',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ 'TWO_FACTOR_AUTHENTICATION.RESET.TITLE' | translate }}
      </h4>
    </div>
    <div class='modal-body'>
      {{ 'TWO_FACTOR_AUTHENTICATION.RESET.MESSAGE' | translate }}
    </div>
    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              (click)='pressConfirm.emit(); $event.stopPropagation()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='pressCancel.emit(true); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `
})
export class TwoFactorAuthenticationResetComponent {
  @Output() pressConfirm = new EventEmitter<boolean>();
  @Output() pressCancel = new EventEmitter<boolean>();
}
